/**
 * 1stdibs
 * User: James
 * Date: 1/25/13
 */
'use strict';

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var SoaModel = require('bunsen/models/SoaModel');
var ItemCreator = module.exports = SoaModel.extend();
var Creator = require('bunsen/models/inventory/Creator');
var endpoints = require('dibs-endpoints');
var ReferenceSets = require('bunsen/collections/queryservice/ReferenceSets');

var furnitureDefaults = {
        roles: ['DESIGNER'],
        attribution: 'BY',
        creator: {}
    };

var artDefaults = {
        attribution: 'BY',
        creator: {}
    };

_.extend(ItemCreator.prototype, {
    relations: [{
        key: 'creator',
        relatedModel: Creator,
        type: Backbone.One
    }],
    /**
     * Gets the unknown creator model.
     * @returns {*} promise
     */

    //This is throwing an error because endpoints is not defined
    //This has not been fixed in Bunsen Master https://github.com/1stdibs/bunsen/blob/master/js/src/dibslibs/models/link-models/ItemCreator.js
    //Also, there is no unknownCreator endpoint in the bunsen endpoints file

    fetchUnknownCreator: function () {
        return this.get('creator').fetch({
            url : endpoints.unknownCreator()
        });
    },
    getRolesString: function () {
        var roles = this.get('roles');
        var roleArr = [];

        if (!ItemCreator.roles) {
            console.warn('You need to call ItemCreator.fetchCreatorRoles before using getRolesString');
            return;
        }

        _.each(roles, function (roleEnum) {
            var roleModel = ItemCreator.roles.findWhere({ enum_name: roleEnum });
            if (roleModel) {
                roleArr.push(roleModel.get('display_name'));
            }
        });

        return roleArr.join(', ');
    }
});

_.extend(ItemCreator, {
    setDefaults: function (defaults) {
        ItemCreator.prototype.defaults = defaults;
    },
    useFurnitureDefaults: function () {
        ItemCreator.setDefaults(furnitureDefaults);
    },
    useArtDefaults: function () {
        ItemCreator.setDefaults(artDefaults);
    },
    fetchCreatorRoles: function (options) {
        var roles = new ReferenceSets();
        return roles.fetchByType('CREATOR_ROLE', options).done(function () {
            ItemCreator.roles = roles;
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/link-models/ItemCreator.js
// module id = 1466
// module chunks = 64